<!-- <ion-button color="primary" (click)="downloadPDF()">
  <ion-icon name="download-outline" slot="start"></ion-icon>
  Download PDF
</ion-button> -->
<div>
  <span class="icon-download fs-20 material-icons" (click)="downloadPDF()">download</span>
</div>
<div id="noDuesForm" class=" no-dues-form">

  <ion-icon name="close-circle-outline" class="close-icon" (click)="closeForm()"></ion-icon>
  <ion-card>
    <ion-card-header class="text-center">
      <ion-card-title class="fs-18 fw-bold">
        No Dues cum Asset Handover Form
      </ion-card-title>
      <p class="fs-14 text-muted">
        Ensure all assets and responsibilities are properly handed over before issuing the
        <span *ngIf="employee.resignationDate">Relieving & Experience</span>
        <span *ngIf="employee.terminationDate">Termination</span>
        Letter.
      </p>


    </ion-card-header>
  </ion-card>

  <!-- A. Employee Information -->
  <ion-card>
    <ion-card-header>
      <ion-card-title> Employee Information </ion-card-title>
    </ion-card-header>

    <ion-card-content>
      <ion-grid>

        <ion-row>
          <ion-col size="3"><b>Employee Name</b></ion-col>
          <ion-col>{{employee.name}}</ion-col>

          <ion-col size="3"><b>Last Working Date</b></ion-col>
          <ion-col>{{employee.lastWorkingDate}} </ion-col>
        </ion-row>

        <ion-row *ngIf="employee.resignationDate">
          <ion-col size="3"><b>Date of Resignation</b></ion-col>
          <ion-col>{{employee.resignationDate}}</ion-col>

          <ion-col size="3"><b>Employee Code</b></ion-col>
          <ion-col>{{employee.code}}</ion-col>
        </ion-row>
        <ion-row *ngIf="employee.terminationDate">
          <ion-col size="3"><b>Date of Termination</b></ion-col>
          <ion-col>{{employee.terminationDate}}</ion-col>

          <ion-col size="3"><b>Employee Code</b></ion-col>
          <ion-col>{{employee.code}}</ion-col>
        </ion-row>
        <ion-row *ngIf="!employee.resignationDate && !employee.terminationDate">
          <ion-col size="3"><b>Date of Resignation / Termination</b></ion-col>
          <ion-col>{{employee.resignationDate}}</ion-col>

          <ion-col size="3"><b>Employee Code</b></ion-col>
          <ion-col>{{employee.code}}</ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>

  <!-- B. Asset Return Section -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Asset Return Section</ion-card-title>
      <p class="text-muted fs-13">Auto-populated from Asset Allocation Master</p>
    </ion-card-header>

    <ion-card-content>
      <ion-grid>

        <ion-row class="table-header">
          <ion-col size="1">Sr.</ion-col>
          <ion-col size="2">Asset / Item</ion-col>
          <ion-col size="2">Approving Authority</ion-col>
          <ion-col size="2">Issued Date</ion-col>
          <ion-col size="2">Return Date</ion-col>
          <ion-col size="1">Status</ion-col>
          <ion-col size="1">Comment</ion-col>
        </ion-row>



        <ion-row *ngFor="let item of allUsers; let i = index" class="table-row ion-text-left">
          <ion-col size="1">{{ i + 1 }}</ion-col>
          <ion-col size="2">{{ item.assetName }}</ion-col>
          <ion-col size="2">{{ item.allocatingAuthorityName }}</ion-col>
          <ion-col size="2">{{ item.dateOfAllocation |date :'dd-MM-yyyy' }}</ion-col>

          <ion-col size="2">
            <mat-form-field class="w-100 mat-height40 mat-input-style">
              <input matInput [matDatepicker]="picker" [(ngModel)]="item.returnDate" (dateChange)="onToggleChange(item)"
                placeholder="Select date" readonly
                [disabled]="item.allocatingAuthorityName!==loggedInUserName ||report=='report'||report=='elcm' ||(item.authorityDepartmentComment=='RECEIVED_AFTER_EXIT' &&item.authorityFinalComment!==null )" />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </ion-col>

          <ion-col size="1">
            <ion-toggle color="success" [(ngModel)]="item.returned" (ionChange)="confirmToggleChange(item)"
              [disabled]="item.allocatingAuthorityName!==loggedInUserName||report=='report'||report=='elcm' ||item.returned"></ion-toggle>
          </ion-col>
          <ion-col size="2">
            <textarea class="edittextareaforauthority w-100 mat-height40 mat-input-style"
              [(ngModel)]="item.authorityFinalComment" (blur)="managerComment(item)" placeholder="Enter Comment"
              maxlength="255" [ngModelOptions]="{ standalone: true }"
              [disabled]="item.allocatingAuthorityName!==loggedInUserName ||report=='report'||report=='elcm' ||(item.authorityDepartmentComment=='RECEIVED_AFTER_EXIT' &&item.authorityFinalComment!==null )">
              </textarea>

          </ion-col>
        </ion-row>

        <!-- ✅ Clearance Summary -->
        <ion-row>
          <ion-col>
            <ion-badge color="danger" *ngIf="!isAllCleared()">Clearance Summary: Pending</ion-badge>
            <ion-badge color="success" *ngIf="isAllCleared()">Clearance Summary: Cleared</ion-badge>
          </ion-col>
        </ion-row>

      </ion-grid>
    </ion-card-content>
  </ion-card>

  <!-- C. Manager Verification Section -->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Manager Verification Section</ion-card-title>
    </ion-card-header>

    <ion-card-content>
      <ion-grid>
        <ion-row class="table-header">
          <ion-col size="1">Sr.</ion-col>
          <ion-col size="4">Activity</ion-col>
          <ion-col size="3">Reporting Manager</ion-col>
          <ion-col size="2">Status</ion-col>
          <ion-col size="2">Comments</ion-col>
        </ion-row>

        <ion-row *ngFor="let m of managerTasks; let i=index" class="table-row">
          <ion-col size="1">{{i+1}}</ion-col>
          <ion-col size="4">{{m.activity}}</ion-col>
          <ion-col size="3">{{m.reportingManager}}</ion-col>
          <ion-col size="2">
            <ion-toggle color="success" [(ngModel)]="m.status"
              [disabled]="employee.managerCode!==empCode ||report=='report'" (ionChange)="verifymanager(m)">

            </ion-toggle>
            <div style="margin-left: 15px;">
              {{m.status?"Yes":"No"}}
            </div>
          </ion-col>
          <ion-col size="2">

            <textarea class="edittextareaforauthority w-100 mat-height40 mat-input-style" placeholder="Enter comment"
              [(ngModel)]="m.comment" (focus)="m._oldComment = m.comment" (focusout)="onCommentBlur(m)"
              [disabled]="employee.managerCode !== empCode ||report=='report'" maxlength="255"
              [ngModelOptions]="{ standalone: true }">
             </textarea>

          </ion-col>

        </ion-row>
        <ion-row>
          <ion-col>
            <ion-badge color="danger" *ngIf="!isAllCompletedManager()">Clearance Summary: Pending</ion-badge>
            <ion-badge color="success" *ngIf="isAllCompletedManager()">Clearance Summary: Cleared</ion-badge>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>

  <!-- D. HR Admin Verification Section -->
  <ion-card>
    <ion-card-header>
      <ion-card-title> HR Admin Verification Section</ion-card-title>
    </ion-card-header>

    <ion-card-content>
      <ion-grid>

        <!-- Header Row -->
        <ion-row class="table-header">
          <ion-col size="4"><b>Verification Status</b></ion-col>
          <ion-col size="4"><b>HR Comment</b></ion-col>
          <ion-col size="4" *ngIf="employee.resignationDate"><b>Ready for Relieving / Experience Letter</b></ion-col>
          <ion-col size="4" *ngIf="employee.terminationDate"><b>Ready for Termination Letter</b></ion-col>
          <ion-col size="4" *ngIf="!employee.resignationDate && !employee.terminationDate"><b>Ready forRelieving /
              Experience /Termination Letter</b></ion-col>
        </ion-row>

        <!-- Input Row -->
        <ion-row class="table-row" style="align-items: flex-start;">
          <ion-col size="3">
            <mat-form-field class="w250px mat-height40 mat-input-style">

              <mat-select [(ngModel)]="hrVerification.status"
                [disabled]="!['HR Admin', 'Super Admin', 'MD', 'PHI Admin'].includes(loggedInUserRole)||report=='report' ||mailSendCheck"
                [ngStyle]="{
      'color': hrVerification?.status === 'Verified' ? '#4caf50' :
                          hrVerification?.status === 'Pending' ? '#ff9800' :
                          hrVerification?.status === 'Rejected' ? '#f44336' : '',
    
      'border-radius': '6px',
      'padding': '4px 10px',
      'text-align': 'center'
    }">
                <mat-option value="Pending">Pending</mat-option>
                <mat-option value="Verified">Verified</mat-option>
                <mat-option value="Rejected">Rejected</mat-option>
              </mat-select>

            </mat-form-field>

          </ion-col>


          <ion-col size="6">
            <!-- <ion-textarea placeholder="Enter HR remarks" [(ngModel)]="hrVerification.comment" auto-grow="true"> -->
            <!-- </ion-textarea> -->
            <textarea rows="3" cols="32" class="edittextarea" [(ngModel)]="hrVerification.comment" [disabled]="(loggedInUserRole !== 'HR Admin' &&
              loggedInUserRole !== 'Super Admin' &&
              loggedInUserRole !== 'MD' &&
              loggedInUserRole !== 'PHI Admin')||report=='report' ||mailSendCheck" placeholder="Enter HR remarks"
              maxlength="255" [ngModelOptions]="{ standalone: true }">
                      </textarea>

          </ion-col>


          <ion-col size="3">

            <mat-form-field class="w250px mat-height40 mat-input-style">

              <mat-select [(ngModel)]="hrVerification.readyForLetter" [disabled]="(loggedInUserRole !== 'HR Admin' &&
              loggedInUserRole !== 'Super Admin' &&
              loggedInUserRole !== 'MD' &&
              loggedInUserRole !== 'PHI Admin')||report=='report' ||mailSendCheck"
                (selectionChange)="onReadyForLetterChange(hrVerification)">
                <mat-option value="Yes">Yes</mat-option>
                <mat-option value="No">No</mat-option>

              </mat-select>
            </mat-form-field>
          </ion-col>
        </ion-row>

      </ion-grid>
    </ion-card-content>
  </ion-card>


</div>